let powFeatures: string[] = [];

export const POW_FEATURES = {
	paSubscriptions: "paSubscriptions",
	paSubscriptions_Add: "paSubscriptions_Add",
	paSubscriptions_AllLogs: "paSubscriptions_AllLogs",
	paSubscriptions_CallLogs: "paSubscriptions_CallLogs",
	paSubscriptions_ChannelLogs: "paSubscriptions_ChannelLogs",
	paSubscriptions_WorkerLogs: "paSubscriptions_WorkerLogs",
	paSubscriptions_Licenses: "paSubscriptions_Licenses",
	paSubscriptions_ModifyAdditionalConfig: "paSubscriptions_ModifyAdditionalConfig",
	paSubscriptions_NamedResources: "paSubscriptions_NamedResources",
	paSubscriptions_Versions: "paSubscriptions_Versions",
	paSubscriptions_Details_DownloadWorkers: "paSubscriptions_Details_DownloadWorkers",
	paConfigurations: "paConfigurations",
	paConfigurations_Admin: "paConfigurations_Admin",
	paFeatures: "paFeatures",
	paFeatures_Admin: "paFeatures_Admin",
	paPlatformEvents: "paPlatformEvents",
	paReports: "paReports",
	paReports_Admin: "paReports_Admin",
	paVersions: "paVersions",
	paVersions_Admin: "paVersions_Admin",
	paInvoices: "paInvoices",
	pdpAdminMenu: "pdpAdminMenu",
	pdpAdminUsers: "pdpAdminUsers",
	pdpAdminCLELogger: "pdpAdminCLELogger",
	pdpAdminTestReports: "pdpAdminTestReports",
	pdpAdminServiceLogLevels_View: "pdpAdminServiceLogLevels_View",
	pdpAdminServiceLogLevels_Edit: "pdpAdminServiceLogLevels_Edit",
};

export const initPowFeatures = (features: string[]) => {
	if (features && Array.isArray(features)) {
		powFeatures = [...features];
	}
};

export const hasPowFeature = (featureName: string) => {
	return powFeatures && powFeatures.indexOf(featureName) > -1;
};
